module.exports = __webpack_public_path__ + "fonts/Roboto-BoldItalic.60c1f67.ttf";